import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    // currentTarget is cleared once the click has been dispatched, so read it
    // before the clipboard promise resolves.
    const button = event.currentTarget

    navigator.clipboard.writeText(this.textValue).then(() => {
      window.toast('Copied to clipboard', { type: 'success' })

      const originalClass = button.className
      button.classList.add('text-green-600')
      setTimeout(() => { button.className = originalClass }, 2000)
    })
  }
}
